module.exports = __webpack_public_path__ + "static/media/Neo16.329846bb.glb";